// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Ibsc","right":"Footer_right__2jum0","buttons":"Footer_buttons__jUoYw"};